export interface WOStatistics2 {
  uid: number;
  companyUID: number;
  itemName: string;
  displayOrder: number;
  isDeleted: boolean;
}

export const initializeStatistics2: WOStatistics2 = {
  uid: 0,
  companyUID: 0,
  itemName: "",
  displayOrder: 0,
  isDeleted: false,
};

export interface statisticsItem2ListParams {
  token: string;
  page: number;
  rows?: number;
}
export const initialStatisticsItem2ListParams = {
  page: 1,
  token: "",
  rows: 20,
};
